function fixTermsAndConditionsLinks() {
  const agreementLinks = document.querySelectorAll('.cpb-agreement-description a');

  agreementLinks.forEach((link) => {
    const href = link.getAttribute('href');
    if (!href) return;

    try {
      const url = new URL(href, window.location.origin);

      if (url.pathname === '/terms-conditions') {
        link.setAttribute('href', 'https://patternroom.com/pages/terms-and-conditions');
      }
    } catch (e) {}
  });
}

function initTermsFix() {
  fixTermsAndConditionsLinks();

  const observer = new MutationObserver(() => {
    fixTermsAndConditionsLinks();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true,
  });
}

document.addEventListener('DOMContentLoaded', initTermsFix);
document.body.addEventListener('CPB_ON_PRODUCT_MOUNTED', fixTermsAndConditionsLinks);
document.body.addEventListener('CPB_ON_OPTIONS_UPDATE', fixTermsAndConditionsLinks);
document.body.addEventListener('CPB_ON_RENDER_LAYERS', fixTermsAndConditionsLinks);